const { CHATS: Types } = require('../action-types');
const { MESSAGES_SORT_TYPE } = require('../utils/constants');
const Storage = require('../utils/storage');
const PersistenceConfig = require('../utils/persistence-config');

const { keys: PersistenceKeys } = PersistenceConfig;

const initialState = {
    allMessagesSortingType: MESSAGES_SORT_TYPE.BY_DATE_UPDATED,
    messagesToSendOnServer: [],
    collapseHeaders: {
        dms: Storage.get(PersistenceKeys.app.collapseHeadersDms) ?? true,
        groups: Storage.get(PersistenceKeys.app.collapseHeadersGroups) ?? true
    }
};

const reducer = (state = initialState, action) => {

    const { key } = (action.payload || {});

    switch (action.type) {
        case Types.CLEAR:
            delete state[key];
            return state;

        case Types.SET_ALL_MESSAGES_SORTING_TYPE:
            return {
                ...state,
                allMessagesSortingType: action.payload.sortType
            };
        case Types.SET_COLLAPSE_HEADERS_DMS:
            Storage.set(PersistenceKeys.app.collapseHeadersDms, action.payload.setting);
            return {
                ...state,
                collapseHeaders: {
                    ...state.collapseHeaders,
                    dms: action.payload.setting
                }
            };

        case Types.SET_COLLAPSE_HEADERS_GROUPS:
            Storage.set(PersistenceKeys.app.collapseHeadersGroups, action.payload.setting);
            return {
                ...state,
                collapseHeaders: {
                    ...state.collapseHeaders,
                    groups: action.payload.setting
                }
            };

        default:
            return state;
    }
};

const selectors = {
    getChatTextBySid: (state, key) => state[key],
    getAllMessagesSortType: (state) => state.allMessagesSortingType,
    getCollapseHeaders_forDms: (state) => state.collapseHeaders.dms,
    getCollapseHeaders_forGroups: (state) => state.collapseHeaders.groups
};

module.exports = Object.assign(reducer, { selectors });
